import { CheckboxStyled } from '../../CheckboxStyled';
import styled from 'styled-components';
import { rem } from 'polished';

export const CheckboxStyledOVGB = styled(CheckboxStyled)`
    
`;
